import { useStaticQuery, graphql } from "gatsby";

type FooterLink = {
    label: string
    path: string
    target?: string
}

function safeJsonParse<T>(value: unknown, fallback: T): T {
    if (value == null) return fallback
    if (typeof value !== "string") return fallback
    try {
        return JSON.parse(value) as T
    } catch {
        return fallback
    }
}

export const useSiteMetadata = () => {
    const { site } = useStaticQuery(graphql`
        query {
            site {
                siteMetadata {
                    siteName
                    title
                    description
                    featureFlags
                    siteAssets
                    siteLayoutConfigs
                    footerLinks
                }
            }
        }
    `)

    const md = site.siteMetadata as {
        siteName: string
        title: string
        description: string
        featureFlags: string
        siteAssets: string
        siteLayoutConfigs: string
        footerLinks: string
    }

    return {
        ...md,
        footerLinks: safeJsonParse<FooterLink[]>(md.footerLinks, []),
    }
}